export const CARD_TX_STATE = {
    NEW: 'new',
    EXPENSED: 'expensed',
    SKIPPED: 'skipped',
    DELETED: 'deleted',
    DUPLICATE: 'duplicate',
    ADMIN_DRAFT: 'admin_draft'
};
export const CARD_TX_STATE_VALUES = [
    CARD_TX_STATE.NEW,
    CARD_TX_STATE.EXPENSED,
    CARD_TX_STATE.SKIPPED,
    CARD_TX_STATE.DELETED,
    CARD_TX_STATE.DUPLICATE,
    CARD_TX_STATE.ADMIN_DRAFT
];
export const CARD_TX_PROVIDER_STATE = {
    PENDING: 'pending',
    POSTED: 'posted',
    DECLINED: 'declined',
    VOIDED: 'voided'
};
export const CARD_TX_PROVIDER_STATE_VALUES = [
    CARD_TX_PROVIDER_STATE.PENDING,
    CARD_TX_PROVIDER_STATE.POSTED,
    CARD_TX_PROVIDER_STATE.DECLINED,
    CARD_TX_PROVIDER_STATE.VOIDED
];
// eslint-disable-next-line no-shadow
export var CardTransactionScopes;
(function (CardTransactionScopes) {
    CardTransactionScopes["NoPayments"] = "noPayments";
})(CardTransactionScopes || (CardTransactionScopes = {}));
